/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCity = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M8 2h14v20h-8v-4h2v2h4V4H10v7.301l-2-1.2z" />
        <path d="M14 8h-2V6h2zm2 0h2V6h-2zm-2 4h-2v-2h2zm2 0h2v-2h-2zm2 4h-2v-2h2zM7 11.834l5 3V22H2v-7.166zm-3 4.132V20h2v-2h2v2h2v-4.034l-3-1.8z" />
      </g>
    </g>
  </Icon>
);
export { SvgCity as City };
